export default __webpack_public_path__ + "static/media/10.57a68a18.png";